import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./reportForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import InputSelect from "../../../utils/InputSelect";
import InputText from "../../../utils/InputText";
import Breadcrumb from "../../../utils/breadCrumbs";
import { DEPARTMENTS } from "../../../../constants";
import {
  PageHeader,
  BreadcrumbDiv,
  FormContainer,
  SectionTitle,
} from "./reportForm.styled";

const ReportForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, onBack, edit, skills } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.report.title"), path: PATHS.CONFIG },
    { label: edit ? t("forms.report.titleEdit") : t("forms.report.titleNew") },
  ];

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let index = 0; index < 5; index++) {
    years.push({
      code: currentYear - index,
      label: currentYear - index,
    });
  }

  // console.log("skills:", skills);
  // console.log(
  //   "Competencia 2:",
  //   skills ? skills["Competencia 2"] : "skills es null"
  // );

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11">
          <PageHeader>
            <h3>
              {edit ? t("forms.report.titleEdit") : t("forms.report.titleNew")}
            </h3>
            <BreadcrumbDiv>
              <Breadcrumb items={breads} />
            </BreadcrumbDiv>
          </PageHeader>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          {/* <FormContainer> */}
          <form autoComplete="off" onSubmit={handleSubmit}>
            <FormContainer>
              <div className="row mb-3">
                <div className="col-5">
                  <Field
                    id="department"
                    name="department"
                    labelField={t("forms.report.labels.department")}
                    component={InputSelect}
                    placeholder=""
                    optionLabel="label"
                    optionValue="code"
                    options={DEPARTMENTS.map((item) => ({
                      ...item,
                      label: t(item.label),
                    }))}
                    classNamePrefix="dark"
                    mandatory
                  />
                </div>

                <div className="col-2">
                  <Field
                    id="year"
                    name="year"
                    labelField={t("forms.report.labels.year")}
                    component={InputSelect}
                    placeholder=""
                    optionLabel="label"
                    optionValue="code"
                    options={years.map((item) => ({
                      ...item,
                      label: t(item.label),
                    }))}
                    classNamePrefix="dark"
                    addOptionEmpty
                    classNameContainer="flex-grow-1"
                  />
                </div>

                <div className="col-5">
                  <Field
                    id="numEvaluations"
                    labelField={t("forms.report.labels.numEvaluations")}
                    name="numEvaluations"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                  />
                </div>
              </div>
            </FormContainer>
            <FormContainer>
              <div className="row mb-3">
                <div className="col-12">
                  <SectionTitle>
                    <i className="fas fa-bullseye me-2"></i>
                    {t("forms.report.labels.goals")}
                  </SectionTitle>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-4">
                  <Field
                    id="goals1"
                    labelField={t("forms.report.labels.goal1")}
                    name="goals1"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                    max={5}
                  />
                </div>

                <div className="col-4">
                  <Field
                    id="goals2"
                    labelField={t("forms.report.labels.goal2")}
                    name="goals2"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                    max={5}
                  />
                </div>

                <div className="col-4">
                  <Field
                    id="goals3"
                    labelField={t("forms.report.labels.goal3")}
                    name="goals3"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                    max={5}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-6">
                  <Field
                    id="goals4"
                    labelField={t("forms.report.labels.goal4")}
                    name="goals4"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                    max={5}
                  />
                </div>

                <div className="col-6">
                  <Field
                    id="goals5"
                    labelField={t("forms.report.labels.goal5")}
                    name="goals5"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    mandatory
                    max={5}
                  />
                </div>
              </div>{" "}
            </FormContainer>
            <FormContainer>
              <div className="row  mb-3">
                <div className="col-12">
                  <SectionTitle>
                    <i className="fas fa-award me-2"></i>
                    {t("forms.report.labels.competencies")}
                  </SectionTitle>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-4">
                  <Field
                    id="competencies1"
                    labelField={
                      skills
                        ? skills["Competencia 1"]
                        : t("forms.report.labels.competency1")
                    }
                    name="competencies1"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    max={5}
                  />
                </div>

                <div className="col-4">
                  <Field
                    id="competencies2"
                    labelField={
                      skills
                        ? skills["Competencia 2"]
                        : t("forms.report.labels.competency2")
                    }
                    name="competencies2"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    max={5}
                  />
                </div>

                <div className="col-4">
                  <Field
                    id="competencies3"
                    labelField={
                      skills
                        ? skills["Competencia 3"]
                        : t("forms.report.labels.competency3")
                    }
                    name="competencies3"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    max={5}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-6">
                  <Field
                    id="competencies4"
                    labelField={
                      skills
                        ? skills["Competencia 4"]
                        : t("forms.report.labels.competency4")
                    }
                    name="competencies4"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    max={5}
                  />
                </div>

                <div className="col-6">
                  <Field
                    id="competencies5"
                    labelField={
                      skills
                        ? skills["Competencia 5"]
                        : t("forms.report.labels.competency5")
                    }
                    name="competencies5"
                    placeholder=""
                    component={InputText}
                    fieldType="number"
                    max={5}
                  />
                </div>
              </div>{" "}
            </FormContainer>
            <FormContainer>
              <div className="row justify-content-center">
                <div className="col-12 text-center">
                  <button
                    type="button"
                    onClick={() => onBack()}
                    className="btn btn-lg btn-secondary me-2"
                  >
                    {t("forms.report.buttons.cancel")}
                  </button>
                  <button type="submit" className="btn btn-lg btn-primary">
                    {t("forms.report.buttons.save")}
                  </button>
                </div>
              </div>
            </FormContainer>
          </form>
          {/* </FormContainer> */}
        </div>
      </div>
    </>
  );
};

ReportForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const ReportFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ReportForm",
})(ReportForm);

export default ReportFormF;
